import { render, staticRenderFns } from "./PersonalizedGameEditorChoice.vue?vue&type=template&id=1bd0038a&scoped=true&"
import script from "./PersonalizedGameEditorChoice.vue?vue&type=script&lang=js&"
export * from "./PersonalizedGameEditorChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd0038a",
  null
  
)

export default component.exports